import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    bbDangerousStringToDate,
    BBDisableChildren, bbDoesCustomerHaveAccessToModule,
    bbFormattedDateString,
    bbGetRequestedAttackStatusNameFromID,
    bbShortenString, isCurrentUserMemberOf,
    mapObject
} from "../../../util/bbHelpers";
import {
    fetchCustomers, fetchRequestedAttacks,

} from "../../../actions";
import PropTypes from "prop-types";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import Tooltip from "@material-ui/core/Tooltip";
import BBDataTable from "../tables/BBDataTable";
import RequestAttackButton from "../controllers/RequestAttackButton";
import RequestAttackOptionsDialog from "../controllers/RequestAttackOptionsDialog"
import Base64ViewerDialog from "../modals/Base64ViewerDialog"
import {GridCellParams} from "@mui/x-data-grid-pro";
import {Button, Chip} from "@material-ui/core";
// import {GridColParams} from "@mui/x-data-grid";
import {useHistory} from "react-router-dom";
import BBIconAnalysisNetwork from "../../../assets/bbCustomIcons/BBIconAnalysisNetwork";
import AttackTimelineDialog from "../modals/AttackTimelineDialog";
import BBIconOption from "../../../assets/bbCustomIcons/BBIconOption";
import BBIconSpreadInternalAssessment from "../../../assets/bbCustomIcons/BBIconSpreadInternalAssessment";
import BBIconMouseTargetAoD from "../../../assets/bbCustomIcons/BBIconMouseTargetAoD";
import BBIconExpiredClock from "../../../assets/bbCustomIcons/BBIconExpiredClock";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import BBExternalLink from "../accents/BBExternalLink";
// import {useIdleTimer} from "react-idle-timer";

const TableContainer = (props) => {

    const {customerId} = props;

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
  const {customers, loadingCustomers, customerInView} = useSelector(({customer}) => customer);
const {requestedAttacks, loadingRequestedAttacks} = useSelector(({insider}) => insider);
    const {authUser} = useSelector(({auth}) => auth);
const dispatch = useDispatch();
  //select the customer from the store if it exists, based on the props customerId
  // const customer = customers ? customerId ? customers[customerId] : customerInView ? customers[customerInView] : null : null;
    const customer = customers && customerInView ? customers[customerInView] : null;

    //from the customer, pull the ACTIVE target data if it exists
  //   const requestedAttacksForCustomer = customer ? requestedAttacks ? requestedAttacks[customer.CustomerId] ? filterObject(requestedAttacks[customer.CustomerId], (attackKey, attack) => attack["Attack Type"].Id === 0) : null : null : null;
    const requestedAttacksForCustomer = customer ? requestedAttacks ? requestedAttacks[customer.CustomerId] ? requestedAttacks[customer.CustomerId] : null : null : null;
    // const totalNumAttacks = metaAttacks ? metaAttacks[customerId] ?  metaAttacks[customerId].total.perimeter : null : null;
    // const activeTargets = customer ? customer.targets ? filterObject(customer.targets, (_, target) => target.IsActive !== false) : null : null;

    let history = useHistory();

    /*
Periodic reload
 */

    // const handleOnIdle = event => {
    //     // console.log('User Idle for 15s. Will reload Insider Attacks table when they return.', event)
    // }
    //
    // const handleOnActive = event => {
    //
    //     // console.log('time remaining', getRemainingTime())
    //     if (customer && !loadingRequestedAttacks) {
    //         // console.log('User is active, Refreshing Attacks Table');
    //         // console.log('User is active, Refreshing Attacks Table', event);
    //         dispatch(fetchRequestedAttacks({
    //             customerId: customer.CustomerId
    //         }));
    //     }
    // }

    // const handleOnAction = (e) => {
    //     // console.log('user did something', e);
    //     // console.log('User is active and 10s have elapsed.');
    //     handleOnActive(e);
    // }

    // const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    //     timeout: 1000 * 15, //10s min timeout
    //     onIdle: handleOnIdle,
    //     onActive: handleOnActive,
    //     // onAction: handleOnAction,
    //     debounce: 500
    // })

    /*
    END Periodic reload
     */

  useEffect(() => {

      if (!customers && !loadingCustomers) {
          // console.log("Customers is empty, fetching.")
          dispatch(fetchCustomers());
      } else if (customer && requestedAttacksForCustomer === null && !loadingRequestedAttacks) {
          // console.log("vectors is empty, fetching vectors for customerId = ", customer.CustomerId);
          dispatch(fetchRequestedAttacks({
              customerId: customer.CustomerId
          }));
      }

  }, [customers, loadingCustomers, requestedAttacks, customerInView, loadingRequestedAttacks, dispatch, customer, requestedAttacksForCustomer]);

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <div className={"tourStep-InsiderAttacksStatusLog"}>
        Insider Attacks - Status Log <Tooltip title={"View the status of previously requested Insider Attacks: both Attacks on Demand and Internal Assessments."}>
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </div>;

    const onClickToAttackTimeline = (attackId) => {
        history.push(`/board/CIRT/inspector/${customerInView}/attack/${attackId}`)
    }

  const userTableHeadings = [

      // { field: 'id', headerName: 'Attack ID', hide: true, width:300, sortable: true, type: 'string', },
      // { field: 'attackPackageId', headerName: 'Package ID', hide: true, flex : 1.5, sortable: true, type: 'string', },

      { field: 'requestedDateTime',
          headerName: 'Requested',
          sortable: true,
          type: 'dateTime',
          renderCell: (params) => (<Tooltip title={bbFormattedDateString(params.value, "long")}><span>{bbFormattedDateString(params.value, "short")}</span></Tooltip>),
          width : 120,
          // renderHeader: (params: GridColParams) => <strong>Requested</strong>,
          cellClassName: (params: GridCellParams) => params.row.wasRowJustAdded ? "text-electric-blue-light" : "",},
      { field: 'attackTypeName', headerName: 'Attack Type', hide: true, flex : 0.75, sortable: true, type: 'string', renderCell: (params) => (
              renderCellExpand(params, <Tooltip title={`${params.value} | ${params.row.attackTypeDescription}`}>
                    <span>
                        {params.value}
                    </span>
              </Tooltip>)
          ),
          cellClassName: (params: GridCellParams) => params.row.wasRowJustAdded ? "text-electric-blue-light" : "",},
      { field: 'attackTypeId', headerName: 'Type', renderHeader: (params) => <Tooltip title={"Attack Type"}><span><BBIconOption/></span></Tooltip>, hide: false, width:50, sortable: true, type: 'string', renderCell: (params) => (
              <Tooltip title={`${params.row.attackTypeName} | ${params.row.attackTypeDescription}`}>
                    <span>
                        {params.value === 0 //0 is AoD
                            ? <BBIconMouseTargetAoD/>
                            : <BBIconSpreadInternalAssessment/>
                        }
                    </span>
              </Tooltip>
          ),
          cellClassName: (params: GridCellParams) => params.row.wasRowJustAdded ? "text-electric-blue-light" : "",},
      { field: 'attackName', headerName: 'Attack Name', hide: false, flex:2, sortable: true, type: 'string', renderCell: (params) => (
              renderCellExpand(params, params.row.url ?
                  <BBExternalLink href={params.row.url}
                                  tipText={`${params.value} | Learn more about how to use this attack at BreachBits.com.`}>{params.value}</BBExternalLink>

                  :<Tooltip title={`${params.value} | ${params.row.description}`}>
                    <span>
                        {params.value}
                    </span>
                  </Tooltip>

              )

          )},
      { field: 'os', headerName: 'OS', sortable: true, type: 'string', width: 75, renderCell: (params) => (
              <Tooltip title={`Target Operating System: ${params.value} | ${params.row.osDetailsDescription}`}>
                    <span>
                        {params.row.osDetailsLogo && <img style={{height: 18}} src={params.row.osDetailsLogo} alt={`${bbShortenString(params.value, 25, true)}`} />}
                        {(!params.row.osDetailsLogo) && params.value}
                    </span>
              </Tooltip>
          )},

      { field: 'toolkitName', headerName: 'Toolkit', hide: false, width:150, sortable: true, type: 'string', renderCell: (params) => (
              renderCellExpand(params, <Tooltip title={`${params.value} | ${params.row.toolkitDescriptionLong}`}>
                    <span>
                        {params.value}
                    </span>
              </Tooltip>)
          ),
          cellClassName: (params: GridCellParams) => params.row.wasRowJustAdded ? "text-electric-blue-light" : "",},
      { field: 'attackOriginationDomain', headerName: 'Origination', sortable: true, type: 'string', flex: 1.2, renderCell: (params) => (
              renderCellExpand(params,  <Tooltip title={params.value || params.row.attackOriginationIp ? `Attack Origination Domain: ${params.value} | Origination IP: ${params.row.attackOriginationIp}` : "Origination details cannot yet be determined."}>
                    <span>
                        {params.value
                        ? params.value
                        : params.row.attackOriginationIp
                            ? `${params.row.attackOriginationIp}`
                            : "Pending"
                        }
                    </span>
              </Tooltip>)
          ),
          cellClassName: (params: GridCellParams) => params.row.wasRowJustAdded ? "text-electric-blue-light" : "",},

      { field: 'statusName', headerName: 'Status', hide: false, width:150, sortable: true, type: 'string', renderCell: (params) => {
              const isTimelineButtonDisabled = (params.row.statusId === 0 || params.row.statusId === 1 || params.row.statusId === 3);
              const names = bbGetRequestedAttackStatusNameFromID(params.row.statusId);

          return <Tooltip
                  title={`${params.value} | ${params.row.statusDescription} | ${params.row.statusId}`}>
                  <div>
                      <Chip
                          label={names.label}
                          avatar={names.avatar}
                          color={params.row.statusId === 1 ? "primary" : "default"}
                          className={params.row.statusId === 1 || params.row.wasRowJustAdded ? "btn-floating pulse pulse-single" : ""}
                          onClick={!isTimelineButtonDisabled ? () => onClickToAttackTimeline(params.row.id) : null}
                      />
                  </div>

              </Tooltip>
          },
          // cellClassName: (params: GridCellParams) => params.row.wasRowJustAdded ? "text-electric-blue-light" : "",
},

      { field: 'actions', headerName: 'Actions', hide: false, width : 285, sortable: false, type: 'string',
          renderCell: (params) => {
          const isTimelineButtonDisabled = (params.row.statusId === 0 || params.row.statusId === 1 || params.row.statusId === 3);

              let attackButtonElement = <></>
              switch (params.row.statusId) {
                  case 0:
                      attackButtonElement = <>
                          <Base64ViewerDialog
                              attackId={params.row.id}
                              customerId={customer.CustomerId}
                              isDisabled
                              // singlePulse = {params.row.wasRowJustAdded}
                          />
                      </>
                      break;
                  case 1:
                  // case 2:
                  // case 5:
                      attackButtonElement =  <>
                          <Base64ViewerDialog
                              attackId={params.row.id}
                              customerId={customer.CustomerId}
                              displayState={1} //flash green
                              // singlePulse = {params.row.wasRowJustAdded}
                          />
                      </>
                      break;
                  case 2:
                  // case 3:
                      attackButtonElement =  <>
                          <Base64ViewerDialog
                              attackId={params.row.id}
                              customerId={customer.CustomerId}
                              // displayIcon={<BBIconStop/>}
                              // displayState = {3} //3 is stop
                              isDisabled
                              //TODO: remove this line when able to stop attacks
                              // displayIcon={<BBIconStop/>}
                          />
                      </>
                      break;
                  case 3:
                  case 4:
                  case 5:
                  case 6:
                  case 7:
                  case 8:
                      attackButtonElement =  <>
                          <Base64ViewerDialog
                              attackId={params.row.id}
                              customerId={customer.CustomerId}
                              isDisabled
                              //TODO: remove this line when able to stop attacks
                              // displayIcon={<BBIconStop/>}
                          />
                      </>
                      break;
                  case 9: //expired
                      // case 3:
                      attackButtonElement =
                          <Tooltip title={"Request Expired. To launch this attack type, please re-order this attack."}>
                          <span>
                              <Button
                                  variant="outlined"
                                  color="default"
                                  disabled={true}
                                  // size={"small"}
                              >
                                <BBIconExpiredClock/>
                            </Button>

                          </span>
                          </Tooltip>
                      break;
                  default:
                      attackButtonElement =  <>
                          <Base64ViewerDialog
                              attackId={params.row.id}
                              customerId={customer.CustomerId}
                              isDisabled
                          />
                      </>
              }
              return <>
                  <div style={{marginRight:2}}>
                      {attackButtonElement}
                  </div>
                  <div style={{marginRight:2}}>

                      <AttackTimelineDialog
                          attackId={params.row.id}
                          customerId={customer.CustomerId}
                          isTimelineButtonDisabled={isTimelineButtonDisabled}
                          onClickToAttackTimeline={() => onClickToAttackTimeline(params.row.id)}
                      />
                  </div>

                  <div style={{marginRight:2}}>
                      <Tooltip title={isTimelineButtonDisabled ? "Attack Inspector is unavailable for this attack." : "View full attack details in the Attack Inspector."}>
                          <span>
                              <Button
                                  variant="outlined"
                                  // size={"small"}
                                  color="default"
                                  className={!isTimelineButtonDisabled ? "text-electric-blue" : ""}
                                  onClick={() => onClickToAttackTimeline(params.row.id)}
                                  disabled={isTimelineButtonDisabled}
                              >
                              <BBIconAnalysisNetwork />
                          </Button>
                          </span>

                      </Tooltip>
                  </div>

                  <div style={{marginLeft: 2}}>
                      <RequestAttackButton
                          customerId={customer.CustomerId}
                          attackPackageId={params.row.attackPackageId}
                          iconVariant = {2}
                          base64={"test"}
                          // justAdded = {params.row.wasRowJustAdded}
                      />
                  </div>
              </>
          }

          }

  ];

    //peel the state data into a form the dataTable can read
  const tableData = requestedAttacksForCustomer ? mapObject(requestedAttacksForCustomer, (key, requestedAttack) => {
      // console.log("requestedAttack['Requested DateTime']", requestedAttack["Requested DateTime"], bbDangerousStringToDate(requestedAttack["Requested DateTime"]));
    return (
        {
            // requestedAttackObject: requestedAttack,
            customerId: customerInView,
            id: key,
            requestedDateTime: requestedAttack["Requested DateTime"],

            attackName: requestedAttack["Attack Package Details"].Name,
            attackDescription: requestedAttack["Attack Package Details"].Description,

            statusId: requestedAttack.Status.Id,
            statusName: bbGetRequestedAttackStatusNameFromID(requestedAttack.Status.Id).label,
            statusDescription: requestedAttack.Status.Description,

            attackTypeId: requestedAttack["Attack Package Details"]["Attack Package Type"].Id,
            attackTypeName: requestedAttack["Attack Package Details"]["Attack Package Type"].Name,
            attackTypeDescription: requestedAttack["Attack Package Details"]["Attack Package Type"].Description,

            os: requestedAttack["Attack Package Details"].Platform.Name,
            osDetailsLogo: requestedAttack["Attack Package Details"].Platform.Logo,
            osDetailsDescription: requestedAttack["Attack Package Details"].Platform.Description,

            toolkitId: requestedAttack.Toolkit.Id,
            toolkitName: requestedAttack.Toolkit.Name,
            toolkitDescriptionShort: requestedAttack.Toolkit["Description Short"],
            toolkitDescriptionLong: requestedAttack.Toolkit["Description Long"],

            isAttackComplete: requestedAttack["Attack Complete"],

            attackOriginationIp: requestedAttack["Attack Origination Ip"],
            attackOriginationDomain: requestedAttack["Attack Origination Domain"],

            attackPackageId: requestedAttack["Attack Package Details"].AttackPackageId,

            // attackBase64 : requestedAttack.hasOwnProperty("Attack Command Base64") ? requestedAttack["Attack Command Base64"] : null,

            wasRowJustAdded: requestedAttack.hasOwnProperty("BB_FRONTEND_FLAG__JUST_ADDED") ? requestedAttack["BB_FRONTEND_FLAG__JUST_ADDED"] : false,
        }
    )
  }) : null;

    const tableDataAsArray = () => {
        // console.log("Creating humansTableData as array from humanTableData ", tableData);
        let arr=[];
        for (let ob in tableData) {
            // console.log("ob is ", tableData[ob])
            arr.push(tableData[ob]);
        }
        // console.log("resulting array ", arr);
        return arr;
    }

    const calcProgressValue = () => {
        // console.log("tableData", tableData, "totalNumAttacks", totalNumAttacks, "metaAttacks", metaAttacks)
        // if (totalNumAttacks === 0){
        //     return 100;
        // } else if (!totalNumAttacks || !tableData) {
        //     return 0;
        // } else {
        //         return Object.keys(tableData).length / totalNumAttacks * 100;
        //     }

        return !loadingRequestedAttacks ? 100 : 0;
    }

    const calcBufferValue = () => {
        // if (totalNumAttacks === 0){
        //     return 100;
        // } else if (!totalNumAttacks || !tableData) {
        //     return 50;
        // } else {
        //     return (Object.keys(tableData).length + 10) / totalNumAttacks * 100;
        // }
        return !loadingRequestedAttacks ? 50 : 0;
    }

    const calcLoadingState = () => {
        // if (totalNumAttacks === 0){
        //     return false;
        // } else if (Object.keys(tableData).length === 0) {
        //     return true;
        // } else {
        //     return false;
        // }

        return loadingRequestedAttacks || loadingCustomers || !customer;
    }

    return (
        < >
            <BBDataTable
                columns={userTableHeadings}
                rows={tableData ? tableDataAsArray() : []}
                // totalRows={totalNumAttacks ? totalNumAttacks : 0}
                progressValue={calcProgressValue()}
                bufferValue={calcBufferValue()}
                title={title}
                enableExport
                loading={calcLoadingState()}
                topRightElement= {
                    <div className={"row "}>
                        <BBDisableChildren
                            isDisabled={bbDoesCustomerHaveAccessToModule(customer, "insider") || (isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff"))}
                            moduleRequired = {"insider"}
                            isCompact
                            isButtonSized
                            blurLevel={2}
                        >
                        <div className={"col-12 align-self-center"}>
                            <RequestAttackOptionsDialog />
                        </div>
                        </BBDisableChildren>
                        {/*<div className={"col-2 align-self-center"}>*/}
                        {/*    <BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("insider", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "insider")} iconSize={"40px"}/>*/}
                        {/*</div>*/}
                    </div>
                }
                // defaultSortModel = {[
                //     {
                //         field: 'requestedDateTime',
                //         sort: 'desc',
                //     }
                //
                // ]}
                />
        </>
    );



}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer